import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CatalogueItem } from '../model/catalogue-category/catalogue-item.model';
import { CatalogueService } from '../web-services/catalogue.service';
import { AnalyticalTest } from '../model/analytical-test/analytical-test.model';
import { IProduct } from '../model/contract/product.contract';

type CartItem = CatalogueItem | AnalyticalTest;

@Injectable()
export class ProductResolver  {
    constructor(private catalogueService: CatalogueService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IProduct> | Promise<IProduct> | IProduct {
        return this.catalogueService.getCurrentProduct(+route.params['pid']);
    }
}
